import userManager from '../user-manager'

export default {
  namespaced: true,
  state: {
    user: null,
    isExpired: false
  },
  getters: {
    isAuthenticated: state => {
      return state.user != null //&& !state.isExpired
    }
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
      if (user) {
        localStorage.setItem('token', user.access_token);
      }
    },
    setIsExpired(state, val) {
      state.isExpired = !!val
    }
  },
  actions: {
    loadUser(context) {
      return userManager.getUser().then(function (user) {
        if (user) {
          context.commit('setUser', user)
        } else {
          context.commit('setUser', null)
        }
      });
    }
  },
  modules: {
  }
}